var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiMarkerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#77B9DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.80534L3.45455 9.47709C7.06909 5.32278 12.9309 5.32278 16.5455 9.47709L18 7.80534C13.5855 2.73155 6.42182 2.73155 2 7.80534ZM7.81818 14.4924L10 17L12.1818 14.4924C10.9818 13.1048 9.02545 13.1048 7.81818 14.4924ZM4.90909 11.1489L6.36364 12.8206C8.37091 10.5136 11.6291 10.5136 13.6364 12.8206L15.0909 11.1489C12.2836 7.92236 7.72364 7.92236 4.90909 11.1489Z",
    fill: "#77B9DF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiMarkerIcon);
export default __webpack_public_path__ + "static/media/wifi-marker-icon.c016756537e800ae39fd3e4163c2bc32.svg";
export { ForwardRef as ReactComponent };